const LOWERCASE = "abcdefghijklmnopqrstuvwxyz";
const UPPERCASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const DIGITS = "0123456789";
const SYMBOLS = "!@#$%&*";
const ALL_CHARS = LOWERCASE + UPPERCASE + DIGITS + SYMBOLS;

const pickChar = (charset) => {
  const values = new Uint32Array(1);
  crypto.getRandomValues(values);
  return charset[values[0] % charset.length];
};

const shuffle = (chars) => {
  const result = [...chars];
  for (let i = result.length - 1; i > 0; i -= 1) {
    const values = new Uint32Array(1);
    crypto.getRandomValues(values);
    const j = values[0] % (i + 1);
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
};

export const generatePassword = (length = 12) => {
  const safeLength = Math.max(length, 8);
  const required = [
    pickChar(LOWERCASE),
    pickChar(UPPERCASE),
    pickChar(DIGITS),
    pickChar(SYMBOLS),
  ];
  const remaining = Array.from({ length: safeLength - required.length }, () =>
    pickChar(ALL_CHARS),
  );

  return shuffle([...required, ...remaining]).join("");
};
